export const mapToCount = ({ count }: { count: number }): number => count;
